import { getRoot, Instance, types } from 'mobx-state-tree';
import { PageModel, PageRoutes, RootType } from '../../../internal';
import { quizImageStoredPath, quizImageUrl } from '../../../utils/api/QuizApi';

export const KreirajPitanjeModel = types
  .compose(
    PageModel,
    types.model({
      questionText: types.optional(types.string, ''),
      orderNumber: types.optional(types.number, 0),
      isActive: types.optional(types.boolean, true),
      image: types.optional(types.maybeNull(types.string), null),
    })
  )
  .views((self) => ({
    get root(): RootType {
      return getRoot(self);
    },
    get imageUrl(): string {
      return quizImageUrl(self.image);
    },
  }))
  .actions((self) => ({
    setQuestionText(value: string) {
      self.questionText = value;
    },
    setOrderNumber(value: number) {
      self.orderNumber = value;
    },
    setIsActive(value: boolean) {
      self.isActive = value;
    },
    removeImage() {
      self.image = null;
    },
    setImage(value: string | null) {
      self.image = value;
    },
    async uploadImage(file: File) {
      const { quizId } = self.root.router.queryParams;
      try {
        const filename = await self.root.api.quiz.uploadQuestionImage(
          Number(quizId),
          file
        );
        this.setImage(quizImageStoredPath(filename));
      } catch (err: any) {
        const message =
          err?.response?.data?.message ??
          'Došlo je do greške pri otpremanju slike.';
        self.root.showFailure(message, null);
      }
    },
    async beforePageEnter() {
      self.questionText = '';
      self.orderNumber = 0;
      self.isActive = true;
      self.image = null;
      Promise.resolve(true);
    },
    navigateBack() {
      const { quizId } = self.root.router.queryParams;
      self.root.router.navigate({
        newView: PageRoutes.Pitanja.id,
        queryParams: { quizId },
      });
    },
    async submit() {
      const { quizId } = self.root.router.queryParams;
      try {
        await self.root.api.quiz.createQuestion(Number(quizId), {
          questionText: self.questionText,
          orderNumber: self.orderNumber,
          isActive: self.isActive,
          ...(self.image ? { image: self.image } : {}),
        });
        this.navigateBack();
      } catch (err: any) {
        const message =
          err?.response?.data?.message ??
          'Došlo je do greške pri čuvanju pitanja.';
        self.root.showFailure(message, null);
      }
    },
  }))
  .named('KreirajPitanjeModel');

export type KreirajPitanjeModelType = Instance<typeof KreirajPitanjeModel>;
